import { Button } from '@welbe/design-system';
import React from 'react';
import { ActionContainer, Info } from './CancelConfirmation.styles';

interface CancelConfirmationProps {
	onBack: () => void;
	onConfirm: () => void;
}

export const CancelConfirmation = ({
	onBack,
	onConfirm,
}: CancelConfirmationProps): JSX.Element => {
	return (
		<>
			<Info>¿Deseas salir sin guardar?</Info>
			<ActionContainer>
				<Button variant="outline" onClick={onBack}>
					Regresar
				</Button>
				<Button onClick={onConfirm}>Salir</Button>
			</ActionContainer>
		</>
	);
};
